import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const OTPInputBox = ({ onBack, buttonName, onNext }) => {
  const [otp, setOtp] = useState('');

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  const handleSubmit = () => {
    if (otp) {
      console.log('Password changed to:', otp);
      onNext()
    }
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            border: 'none',
            '&:hover': {
              border: 'none',
            }
          }}
          onClick={onBack}
        >
          <ArrowBackIcon/> Back
        </Button>
      </Box>
      <Typography variant="h5" sx={{ fontWeight: '600', paddingBottom:"5px" }}>{buttonName}?</Typography>
      <Typography variant="h6" sx={{ marginTop: "3px", paddingBottom:"5px" }}>Enter the OTP</Typography>
      <TextField
        value={otp}
        onChange={handleChange}
        label="OTP"
        variant="outlined"
        fullWidth
        sx={{ mt: 2, paddingBottom:"5px" }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          mt: 2,
          backgroundColor: "#f5365c",
          borderColor: "#f5365c",
          '&:hover': {
            backgroundColor: '#f5365c',
            color: 'white',
            border: 'none',
          }
        }}
        onClick={handleSubmit}>
        Submit
      </Button>

    </Box>
  );
};

export default OTPInputBox;
